import {mainButton, secondaryButton} from "@telegram-apps/sdk-react";

let onClickMain = () => {};
let onClickSecondary = () => {};

export const setOnClickMainButton = (onClick: () => void) => {
  mainButton.offClick(onClickMain);
  onClickMain = onClick;
  return mainButton.onClick(onClick);
}

export const setOnClickSecondaryButton = (onClick: () => void) => {
  if (secondaryButton.isSupported()) {
    secondaryButton.offClick(onClickSecondary);
    onClickSecondary = onClick;
    return secondaryButton.onClick(onClick);
  }
}
